import getSeriesStreakItemId from '@/components/Series/SeriesStreakBar/internal/getSeriesStreakItemId'

export default function scrollToSeriesStreakItem(index: number) {
  const element = document.getElementById(getSeriesStreakItemId(index))
  if (element == null) {
    return
  }

  const parent = element.parentElement
  if (parent == null) {
    return
  }

  const parentWidth = parent.clientWidth
  const elementLeft = element.offsetLeft
  const elementWidth = element.offsetWidth
  const scrollPosition = elementLeft - parentWidth / 2 + elementWidth / 2

  parent.scrollTo({
    left: Math.max(0, scrollPosition),
    behavior: 'smooth',
  })
}
